<template>
  <div class="w flex">
    
    <LeftMenu :user-info="userInfo" @sign-in="handleSignIn" @logout="handleLogout" />
    <div class="menu-right">
      <div class="carousel-container">
        <el-carousel height="532px" arrow="always" indicator-position="none" :autoplay="!showWordBookDialog">
          <el-carousel-item v-for="(item, index) in carousel" :key="index">
            <img :src="item.image" class="carousel-image" :alt="item.title" @click="handleCarouselClick(item)" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="flex align-center justify-between margin-top-30">
        <div class="item-li radius-12 w-410 h-204 flex align-center justify-center flex-direction"
          v-for="(item, index) in source" :key="index" :style="{
            backgroundColor: item.bg,
          }" @click="handleItem(item)">
          <img :src="item.icon" :style="{
            width: item.w + 'px',
            height: item.h + 'px',
          }" />
          <div class="text-bold text-18 text-000">{{ item.name }}</div>
          <div class="text-9 text-000 padding-top-30 padding-lr-10">{{ item.desc }}</div>
        </div>
      </div>
    </div>

    
    <Definition :visible="showDefinitionDialog" :word-data="definitionWordData" :progress="definitionProgress"
      :title="definitionTitle" @close="handleDefinitionClose" @play-audio="handlePlayAudio"
      @next-word="handleNextWord" />

    
    <WordBookDialog ref="wordBookDialog" :visible.sync="showWordBookDialog" :word-data="wordBookData"
      :progress="wordBookProgress" :title="wordBookTitle" :show-close="false" @close="handleWordBookClose"
      @play-audio="handleWordBookPlayAudio" @next-word="handleWordBookNextWord" @smilingFace="smilingFace" />
    
    <DictationDialog ref="dictationDialog" :visible.sync="dictationDialogVisible" :write.sync="write"
      :word-data="wordBookData" :progress="wordBookProgress" :title="wordBookTitle" :type="reviewType"
      :current-index="wordBookData?.current_index || 1" :total-words="wordBookData?.total || 0" :use-review-api="true"
      :is-phonics-mode="false"
      @close="handleDictationClose" @next="handleDictationNext" @skip="handleDictationSkip"
      @enter="handleDictationEnter" />

    
    <LearningCompletedDialog :visible="showLearningCompletedDialog" :progress="learningProgress" :title="learningTitle"
      :message="learningMessage" :button-text="learningButtonText" @close="handleLearningCompletedClose"
      @start-test="handleStartTest" />

    <el-dialog :visible.sync="dialogVisible" :width="dialogWidth" :show-close="false" @close="handleClose"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div class="">
        <div class="text-center text-main text-23">抗遗忘</div>
        <div class="lout text-bold text-18 padding-10" @click="handleLogout">退出</div>
        <div class="text-center text-23 padding-bottom-20">
          <div class="padding-tb-86 text-20 text-000-color">请先进行复习！</div>
          <el-button type="primary" class="custom-button-common" @click="handleStartTest">
            开始测试
          </el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { fetchCarousel, submitReviewAnswer } from "@/api/common";
import forcedReviewMixin from "@/mixins/forcedReviewMixin";
import DictationDialog from "@/components/DictationDialog.vue";

export default {
  name: "Home",
  mixins: [forcedReviewMixin],
  components: {
    DictationDialog,
  },
  data() {
    return {
      
      userInfo: {
        name: "学生名称",
        avatar: require("@/assets/icon1.png"),
        isSignedIn: false,
      },
      audioPlayer: null,
      dialogVisible: false,
      dialogWidth: '629px',
      showDefinitionDialog: false,
      showWordBookDialog: false,
      definitionWordData: {},
      definitionProgress: "0/30",
      definitionTitle: "Unit 1",
      wordBookData: {},
      wordBookProgress: "1/10",
      wordBookTitle: "单词本",
      
      showLearningCompletedDialog: false,
      learningProgress: 100,
      learningTitle: "学习完成",
      learningMessage: "恭喜您完成了本次学习！",
      learningButtonText: "开始测试",
      carousel: [],
      source: [
        {
          name: "在线学习系统",
          desc: "提供丰富的在线课程资源，支持随时随地学习。",
          icon: require("@/assets/icon12.png"),
          bg: "#F2F0FE",
          w: "133",
          h: "92",
        },
        {
          name: "练习系统",
          desc: "系统化的练习题库，帮助巩固学习成功成果。",
          icon: require("@/assets/icon13.png"),
          bg: "#EAF6FD",
          w: "80",
          h: "82",
        },
        {
          name: "学习进度",
          desc: "实时跟踪学习进度，科学规划学习路径。",
          icon: require("@/assets/icon14.png"),
          bg: "#DDE7FD",
          w: "102",
          h: "102",
        },
      ],
    };
  },
  created() {
    this.getCarousel();
    const needReview = localStorage.getItem("need-review");
    if (needReview === "true") {
      this.dialogVisible = true;
    }
    this.updateDialogWidth();
  },
  mounted() {
    window.addEventListener('resize', this.updateDialogWidth);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateDialogWidth);
  },
  computed: {
    ...mapState(["count"]),
  },
  
  methods: {
    ...mapActions(["increment", "decrement"]),
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          
          this.$bus.$emit('user-logout');

          
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("token");
          localStorage.removeItem("need-review");
          
          this.clearUserInfo();
          
          this.$router.push("/login");

          this.$message.success("退出登录成功！");
        })
        .catch(() => {
          
        });
    },
    
    handleItem(item) {
      
      switch (item.name) {
        case "在线学习系统":
          this.$router.push("/online-learning");
          break;
        case "练习系统":
          
          let userInfo = this.$store.state.userInfo || {};
          
          if (userInfo.is_mistake === undefined) {
            const userInfoStr = localStorage.getItem('userInfo');
            if (userInfoStr) {
              const parsedInfo = JSON.parse(userInfoStr);
              if (parsedInfo && typeof parsedInfo === 'object') {
                userInfo = parsedInfo;
              }
            }
          }
          
          
          if (userInfo.is_mistake === 2) {
            this.$message.error('练习系统功能已禁用');
            return;
          }
          
          this.$router.push("/practice-system");
          break;
        case "学习进度":
          this.$router.push("/learning-progress");
          break;
        default:
      }
    },

    
    showDefinition() {
      this.showDefinitionDialog = true;
    },

    
    handleDefinitionClose() {
      this.showDefinitionDialog = false;
    },
    handleDictationEnter() {
      const difficultStudyId = this.wordBookData?.difficult_study_id;
      const currentIndex = this.wordBookData?.current_index || 1;
      const answer = (this.write || "").trim();
      if (!difficultStudyId) {
        this.$message.error("数据不完整，无法提交答案");
        return;
      }
      if (!answer) {
        this.$message.warning("请输入答案");
        return;
      }

      submitReviewAnswer({
        type: this.reviewType || "1",
        difficultStudyId: difficultStudyId.toString(),
        currentIndex: currentIndex.toString(),
        action: "0",
        answer: answer
      })
        .then((res) => {
          this.handleDictationNext(res.data);
          this.write = "";
        })
        .catch((error) => {
          this.$message.error("提交答案失败，请稍后重试");
        });
    },

    
    handlePlayAudio() {
      const attachfile = this.definitionWordData?.vocabulary_info?.attachfile;
      if (!attachfile) {
        this.$message.warning("音频文件不存在");
        return;
      }
      
      const audio = new Audio(attachfile);
      audio.play().catch((error) => {
        this.$message.error("播放音频失败，请稍后重试");
      });
    },

    
    handleNextWord() {
      this.$message.success("下一个单词功能开发中...");
    },

    

    
    handleWordBookClose() {
      this.showWordBookDialog = false;
    },
    
    handleWordBookPlayAudio(wordData) {
      const attachfile = this.wordBookData?.vocabulary_info?.attachfile;
      if (!attachfile) {
        this.$message.warning("音频文件不存在");
        return;
      }
      
      const audio = new Audio(attachfile);
      audio.play().catch((error) => {
        this.$message.error("播放音频失败，请稍后重试");
      });
    },

    
    handleWordBookNextWord() {
      
      this.showWordBookDialog = false;

      
      setTimeout(() => {
        this.showDefinitionDialog = true;
      }, 300);
    },

    
    showLearningCompleted() {
      this.showLearningCompletedDialog = true;
    },

    
    handleLearningCompletedClose() {
      this.showLearningCompletedDialog = false;
    },

    
    handleClose() {
      this.dialogVisible = false;
    },

    
    handleSignIn(userInfo) {
      this.userInfo.isSignedIn = true;
      this.$message.success("签到成功！");
    },

    
    handleLogout() {
      this.$confirm("确定要退出登录吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          
          localStorage.removeItem("isLoggedIn");
          localStorage.removeItem("username");

          
          this.$router.push("/login");

          this.$message.success("退出登录成功！");
        })
        .catch(() => {
          
        });
    },
    
    getCarousel() {
      fetchCarousel()
        .then((res) => {
          this.carousel = res.data || [];
        })
        .catch(() => { });
    },
    
    handleCarouselClick(item) {
      if (item.path) {
        
        
      }
    },
    
    updateDialogWidth() {
      const width = window.innerWidth;
      if (width >= 600 && width <= 767) {
        this.dialogWidth = '90%';
      } else if (width >= 768 && width <= 1024) {
        this.dialogWidth = '85%';
      } else if (width >= 1025 && width <= 1440) {
        this.dialogWidth = '75%';
      } else {
        this.dialogWidth = '629px';
      }
    },
  },

};
</script>

<style scoped lang="scss">
.item-li {
  width: 30%;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  transition: all 0.3s ease;
  box-sizing: border-box;
}

.item-li:hover {
  transform: translateY(-5px);
  box-shadow: 0px 8px 8px 0px rgba(0, 0, 0, 0.35);
}

.test-definition-btn {
  background-color: #2a4acc;
  border-color: #2a4acc;
  padding: 12px 30px;
  font-size: 16px;
}

.test-definition-btn:hover {
  background-color: #1e3a9a;
  border-color: #1e3a9a;
}

.test-wordbook-btn {
  background-color: #67c23a;
  border-color: #67c23a;
  padding: 12px 30px;
  font-size: 16px;
  margin-left: 20px;
}

.test-wordbook-btn:hover {
  background-color: #529b2e;
  border-color: #529b2e;
}

.test-learning-completed-btn {
  background-color: #e6a23c;
  border-color: #e6a23c;
  padding: 12px 30px;
  font-size: 16px;
}

.test-learning-completed-btn:hover {
  background-color: #b88230;
  border-color: #b88230;
}

.dialog-flip-enter-active,
.dialog-flip-leave-active {
  transition: all 0.6s ease;
}

.dialog-flip-enter {
  transform: rotateY(90deg);
  opacity: 0;
}

.dialog-flip-leave-to {
  transform: rotateY(-90deg);
  opacity: 0;
}

.dialog-flip-enter-to,
.dialog-flip-leave {
  transform: rotateY(0deg);
  opacity: 1;
}

.carousel-container {
  width: 100%;

}

.carousel-image {
  width: 100%;
  height: 532px;

  cursor: pointer;
}

.lout {
  position: absolute;
  right: 30px;
  top: 30px;
}

@media (min-width: 768px) and (max-width: 1440px) {
  .w {
    width: 94% !important;
    margin: 25px auto !important;
    align-items: flex-start !important;
  }

  .menu-right {
    width: 76% !important;

  }

  .carousel-container {
    ::v-deep .el-carousel {
      height: 420px !important;

      .el-carousel__container {
        height: 420px !important;
      }
    }
  }

  .carousel-image {
    height: 420px !important;
  }

  .item-li {
    .w-410 {
      width: 300px !important;
    }

    .h-204 {
      height: 160px !important;
    }

    .text-18 {
      font-size: 15px !important;
    }

    .padding-top-30 {
      padding-top: 18px !important;
    }

    .text-9 {
      font-size: 12px !important;
    }

    img {
      transform: scale(0.9);
    }
  }

  .margin-top-30 {
    margin-top: 18px !important;
  }

  .padding-tb-86 {
    padding-top: 45px !important;
    padding-bottom: 45px !important;
  }

  .text-23 {
    font-size: 19px !important;
  }

  .text-20 {
    font-size: 17px !important;
  }

  .lout {
    right: 20px !important;
    top: 20px !important;
    font-size: 15px !important;
  }

  ::v-deep {
    .el-dialog {
      width: 85% !important;
      margin-top: 5vh !important;
    }
  }
}

@media (min-width: 768px) and (max-width: 1024px) {
  .w {
    width: 96% !important;
    margin: 20px auto !important;
  }

  .menu-right {
    width: 74% !important;
  }

  .carousel-container {
    ::v-deep .el-carousel {
      height: 340px !important;

      .el-carousel__container {
        height: 340px !important;
      }
    }
  }

  .carousel-image {
    height: 340px !important;
  }

  .item-li {
    .w-410 {
      width: 240px !important;
    }

    .h-204 {
      height: 130px !important;
    }

    .text-18 {
      font-size: 14px !important;
    }

    .padding-top-30 {
      padding-top: 12px !important;
    }

    .text-9 {
      font-size: 11px !important;
    }

    img {
      transform: scale(0.8);
    }
  }

  .margin-top-30 {
    margin-top: 15px !important;
  }

  .padding-tb-86 {
    padding-top: 35px !important;
    padding-bottom: 35px !important;
  }

  .text-23 {
    font-size: 17px !important;
  }

  .text-20 {
    font-size: 15px !important;
  }

  .custom-button-common {
    width: 380px !important;
    height: 48px !important;
  }
}

@media (min-width: 1024px) and (max-width: 1440px) {
  .w {
    width: 95% !important;
  }

  .menu-right {
    width: 75% !important;
  }

  .carousel-container {
    ::v-deep .el-carousel {
      height: 380px !important;

      .el-carousel__container {
        height: 380px !important;
      }
    }
  }

  .carousel-image {
    height: 380px !important;
  }

  .item-li {
    .w-410 {
      width: 270px !important;
    }

    .h-204 {
      height: 145px !important;
    }
  }
}

@media (min-width: 600px) and (max-width: 767px) {
  .w {
    width: 96% !important;
    margin: 8px auto !important;
    align-items: stretch !important;
  }

  .menu-right {
    width: 76% !important;
  }

  .carousel-container {
    ::v-deep .el-carousel {
      .el-carousel__arrow {
        width: 24px !important;
        height: 24px !important;
      }

      .el-carousel__arrow--left {
        left: 5px !important;
      }

      .el-carousel__arrow--right {
        right: 5px !important;
      }

      .el-carousel__indicators {
        bottom: 8px !important;
      }

      .el-carousel__indicator--horizontal {
        padding: 4px 3px !important;
      }

      .el-carousel__indicator--horizontal .el-carousel__button {
        width: 6px !important;
        height: 6px !important;
      }
    }
  }

  .item-li {
    .w-410 {
      width: 180px !important;
    }

    .text-18 {
      font-size: 11px !important;
    }

    .padding-top-30 {
      padding-top: 8px !important;
    }

    .text-9 {
      font-size: 9px !important;
    }

    .padding-lr-10 {
      padding-left: 6px !important;
      padding-right: 6px !important;
    }

   
  }

  .flex {
    gap: 8px !important;
  }

    .padding-lr-10 {
      padding-left: 6px !important;
      padding-right: 6px !important;
    }

  }

  .margin-top-30 {
    margin-top: 10px !important;
  }

  .padding-tb-86 {
    padding-top: 20px !important;
    padding-bottom: 20px !important;
  }

  .text-23 {
    font-size: 14px !important;
  }

  .text-20 {
    font-size: 12px !important;
  }

  .padding-bottom-20 {
    padding-bottom: 15px !important;
  }

  .custom-button-common {
    width: 240px !important;
    height: 36px !important;
    font-size: 13px !important;
  }

  .lout {
    right: 8px !important;
    top: 8px !important;
    font-size: 11px !important;
  }

  ::v-deep {
    .el-dialog {

      margin-top: 2vh !important;
    }
}

::v-deep {
  .el-dialog {
    border-radius: 30px;
    background: linear-gradient(#ffffff 15%, #e8edff 100%);
    box-shadow: none;
  }
}
</style>